import { trackInternalEvent } from '@rio/tracking'
import { Spinner } from 'builder/components/Spinner'
import { UseExampleEvents } from 'builder/modules/constants'
import { useI18n } from 'builder/hooks/useI18n'
import createFromExampleImage from '../assets/create-from-example.svg'
import { useResumePrefill } from '../../hooks/useResumePrefill'
import { Props } from '../types'
import {
  Card,
  CardTitleWrapper,
  CardTitle,
  ImageWrapper,
  Image,
  SpinnerWrapper,
  IconWrapper,
  ArrowIcon,
} from './styles'

export const UseExample = ({ onClose }: Props) => {
  const { i18n } = useI18n()

  const { handleUseExample, hasResumeExamples, fetchingResumeExamples } = useResumePrefill()

  const handleCardClick = () => {
    trackInternalEvent(UseExampleEvents.clickUseAnExampleStartScreen)
    handleUseExample()
    if (hasResumeExamples) {
      onClose()
    }
  }

  return (
    <Card onClick={handleCardClick}>
      <ImageWrapper>
        <Image src={createFromExampleImage} alt="Use resume example" />
      </ImageWrapper>
      <CardTitleWrapper>
        <CardTitle>{i18n.t('builder.use_example.option.heading')}</CardTitle>
      </CardTitleWrapper>
      {fetchingResumeExamples ? (
        <SpinnerWrapper>
          <Spinner />
        </SpinnerWrapper>
      ) : (
        <IconWrapper>
          <ArrowIcon />
        </IconWrapper>
      )}
    </Card>
  )
}
